import { SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { formatCount } from "./runFormatting";

/**
 * #1663: the run page says when the import found a change in the columns of a table. It does not
 * change the run's status. "The data still loaded" is said only of a succeeded run in which no
 * change stopped a table: a type the table cannot hold or a lost key column stops that table, and
 * then the bar says so and where to act. Nothing shows when no table changed.
 */
export function schemaChangeTitle(tables: number): string {
  return `Table structure changed in ${formatCount(tables)} ${tables === 1 ? "table" : "tables"}`;
}

export function schemaChangeMessage(
  tables: number,
  stopped: number,
  succeeded: boolean,
  canAct = true,
): string {
  const which = tables === 1 ? "it" : "each one";
  if (stopped > 0) {
    return `A column change stopped ${formatCount(stopped)} ${stopped === 1 ? "table" : "tables"}, so ${stopped === 1 ? "it" : "they"} did not load. ${canAct ? "Open the changes in the Tables view to widen the column or rebuild the table." : "Ask a contributor to look at the change."}`;
  }
  if (succeeded) {
    return `The data still loaded. The Tables view shows what changed in ${which}.`;
  }
  return `The Tables view shows what changed in ${which}.`;
}

export function SchemaChangeNote({
  tables,
  stopped = 0,
  succeeded = false,
  canAct = true,
}: {
  tables: number;
  stopped?: number;
  succeeded?: boolean;
  canAct?: boolean;
}) {
  if (tables <= 0) return null;
  return (
    <SkyMessageBar
      intent={stopped > 0 ? "warning" : "info"}
      layout="multiline"
      title={schemaChangeTitle(tables)}
      message={schemaChangeMessage(tables, stopped, succeeded, canAct)}
      testId="run-schema-change-note"
    />
  );
}
